<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" rounded color="white">
        <v-icon small class="pr-4">mdi-plus-circle-outline</v-icon>
        Lägg till
      </v-btn>
    </template>
    <MasterdataModal v-if="dialog" :title="createModal.title">
      <component
        :refetch="refetch"
        :is="createModal.component"
        @close="dialog = false"
      />
    </MasterdataModal>
  </v-dialog>
</template>

<script>
import MasterdataModal from './MasterdataModal'

export default {
  name: 'MasterdataCreateButton',

  props: {
    refetch: Function,
    createModal: Object
  },

  components: {
    MasterdataModal
  },

  data: () => ({
    dialog: false
  })
}
</script>
